import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { TRANSLATIONS, LANGS } from "./translations";

const I18nContext = createContext(null);
const STORAGE_KEY = "bsgotech_lang";

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORAGE_KEY) || "pt");

  const setLang = useCallback((l) => {
    if (!LANGS.includes(l)) return;
    localStorage.setItem(STORAGE_KEY, l);
    setLangState(l);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key) => {
      const dict = TRANSLATIONS[lang] || {};
      return dict[key] ?? TRANSLATIONS.en[key] ?? key;
    },
    [lang]
  );

  // localized content helper: obj like { pt: "...", en: "..." }
  const lc = useCallback(
    (obj) => {
      if (obj == null) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] ?? obj.en ?? obj.pt ?? "";
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t, lc }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
